import React from 'react';
import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';

function DynamicTable({ data, columns, actionList, additionalParameterForOperation }) {
  const getOperationValue = (item, column) => {
    const { operation } = column;
    if (!operation) return item[column.key];

    const condition = item[operation.field];
    return condition
      ? operation.true(item, additionalParameterForOperation)
      : operation.false(item, additionalParameterForOperation);
  };

  const getRepresentationValue = (item, column) => {
    let result = column.operation
      ? getOperationValue(item, column)
      : item[column.referredField || column.key];

    if (typeof column.representation === 'function') {
      return column.representation(result, additionalParameterForOperation);
    }
    return result;
  };

  return (
    <div className='table-responsive'>
      <table className='table_white_bg table table-remove-space center_table'>
        <thead>
          <tr className='border_top_0'>
            {columns.map((column, index) => (
              <th key={index} width={column.width}>
                {column.label}
              </th>
            ))}
            {actionList && <th className='text-center'>Action</th>}
          </tr>
        </thead>
        <tbody>
          {data.length ? (
            data.map((item, index) => (
              <tr key={index}>
                {columns.map((column, columnIndex) => (
                  <td key={columnIndex} className={column['className'] || ''}>
                    {column['condition'] ? (
                      <span
                        className={
                          column['condition'][item[column.referredField || column.key]].className
                        }
                      >
                        {column['condition'][item[column.referredField || column.key]].label}
                      </span>
                    ) : column['representation'] ? (
                      getRepresentationValue(item, column)
                    ) : (
                      item[column.referredField || column.key]
                    )}
                  </td>
                ))}
                {actionList && (
                  <td className='text-center'>
                    {actionList.map((action, index) => {
                      const {
                        label,
                        action: actionFunction,
                        icon,
                        className = '',
                        condition,
                        style,
                      } = action;

                      if (
                        condition &&
                        condition[Object.keys(condition)[0]] !== item[Object.keys(condition)[0]]
                      ) {
                        return null; // Skip rendering if condition doesn't match
                      }

                      return (
                        <span
                          key={index}
                          onClick={(event) => actionFunction(event, item)}
                          className='up tooltip-hover-questions'
                        >
                          <div className='tootip_box'>{label}</div>
                          <i className={`${icon} ${className}`} style={style} />
                        </span>
                      );
                    })}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <th colSpan={columns.length + (actionList ? 1 : 0)} className='text-center'>
                <div className='no-qus-found no-mock-exam'>
                  <img
                    width='82px'
                    src={`${App_data.frontend_url}/img/questions/icon_nomock.png`}
                  />
                  <h3 className='mt-1'>{language.LC().NO_MOCK_EXAM_FOUND}</h3>
                </div>
              </th>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DynamicTable;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/DynamicTable.jsx